import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import {ToolProviderResponse} from "@/services/models/toolsResponse";


export const toolsApiSlice = createApi({
    reducerPath: 'toolsApi',
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getTools: builder.query<ToolProviderResponse[], void>({
            query: () => ({
                url: `ToolsProvider`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
    }),
})

const {
    useGetToolsQuery,
} = toolsApiSlice
export const toolsApiActions = {
    useGetToolsQuery,
}